import {
    apiRequest,
    acsosiokulturalCreate,
    masterCategoriessos
} from "../../../../../services/adapters/kepegawaian/Accompetence"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", acsosiokulturalCreate, {
            body: query
        }, true)
    }

    fetchCategories = async (query) => {
        return await apiRequest("get", masterCategoriessos, {
            params: query
        }, true)
    }
}

export default CreateRepository